var humps = require('../../../../utils/humps');

module.exports = Getter;

function Getter () {}
Getter.prototype = _.extend({}, Backbone.Events);
Getter.prototype.initialize = function () {
  this.structure = {};
};

Getter.prototype.get = function (element, attributeChain) {
  this.element = element;
  this.bb = this.element && this.element.getBBox();

  attributeChain = attributeChain || '';
  this.data = {};
  this.collections = {};
  this.processData = {};

  var attributes = this.getChainAttributes(attributeChain);
  var processModels = _.bind(this.processModels, this, attributeChain);

  _.each(_.filter(attributes, isCollectionAttribute), this.processCollections, this);
  _.each(_.filter(attributes, isModelAttribute), processModels, this);
  this.addCollectionResults(attributeChain);

  return this.data;

  function isCollectionAttribute (attribute) {
    return attribute.split('..').length > 1;
  }

  function isModelAttribute (attribute) {
    return !isCollectionAttribute(attribute);
  }
};

Getter.prototype.processCollections = function (finalChain) {
  var keys = finalChain.split('..');
  var collectionName = keys[0];
  var collectionAttribute = keys[1];

  this.collections[collectionName] || createCollection.call(this);

  var collection = this.collections[collectionName];
  var ownGetterMethodName = humps.camelize('get_' + collectionName.replace(/\./g, '_') + '_' + collectionAttribute.replace(/\./g, '_'));
  var remoteGetterMethodName = humps.camelize('get_' + collectionAttribute.replace(/\./g, '_'));

  _.each(this.processData[collectionName], function (result, index) {
    if (!this[ownGetterMethodName] && !result[remoteGetterMethodName]) return;

    var result = result[remoteGetterMethodName]
      ? result[remoteGetterMethodName](index)
      : this[ownGetterMethodName](result, index);

    this.addDataResult(collectionAttribute, result, collection[index]);
  }, this);

  function createCollection () {
    var key = 'get_' + collectionName.replace(/\./g, '_');
    var getterMethodName = humps.camelize(key);

    this.collections[collectionName] = {};
    this.processData[collectionName] = this[getterMethodName]
      ? this[getterMethodName]() : [];

    _.each(this.processData[collectionName], function (result, index) {
      this.collections[collectionName][index] = {};
    }, this);
  }
};

Getter.prototype.addCollectionResults = function (attributeChain) {
  var prev = new RegExp(attributeChain + '[\.]?');

  _.each(this.collections, function (collection, index) {
    this.addDataResult(index.replace(prev, ''), collection);
  }, this);
};

Getter.prototype.processModels = function (attributeChain, finalChain) {
  var key = 'get_' + finalChain.replace(/\./g, '_');
  var getterMethodName = humps.camelize(key);
  var prev = new RegExp(attributeChain + '[\.]?');

  this[getterMethodName] && this.addDataResult(
    finalChain.replace(prev, ''),
    this[getterMethodName]()
  );
};

Getter.prototype.addDataResult = function (attributeChain, result, object) {
  var key, path = _.compact(attributeChain.split('..')[0].split('.'));
  var current = object || this.data;

  if (!path.length) {
    if (object) object = result;
    else this.data = result;
    return;
  }

  while (path.length > 1) {
    key = path.shift();
    if (!current[key]) current[key] = {};
    current = current[key];
  }

  current[path.shift()] = result;
};

Getter.prototype.getChainAttributes = function (attributeChain, obj) {
  obj = obj || this.getChainEnd(attributeChain);
  var attributes = [];

  typeof obj !== 'undefined' && !_.isObject(obj) && attributes.push(attributeChain);

  _.each(obj, function (value, key) {
    if (attributeChain) key = attributeChain + '.' + (_.isArray(obj) ? '' : key);
    if (value) attributes = _.union(attributes, this.getChainAttributes(key, value));
    else attributes.push(key);
  }, this);

  return attributes;
};

Getter.prototype.getChainEnd = function (attributeChain) {
  var key, path = _.compact(attributeChain.split('.'));
  var structureValue = this.structure;

  while (path.length > 0) {
    key = path.shift();
    if (typeof structureValue === 'undefined') {
      return;
    }

    structureValue = structureValue[key];
  }

  return structureValue;
};
